// src/shadowGrove/theme/theme.js

import { LIBERI_COLORS } from "./colors";
import { LIBERI_SHADOWS } from "./shadows";
import { LIBERI_BORDERS } from "./borders";
import { LIBERI_WORLD } from "../world/world";
export const LIBERI_THEME = {
    colors: LIBERI_COLORS,
    shadows: LIBERI_SHADOWS,
    borders: LIBERI_BORDERS,
    world: LIBERI_WORLD,

    names: {
        product: LIBERI_WORLD.realmName,
        internal: "Shadow Grove",
        classroom: LIBERI_WORLD.locations.classroom,
        rewards: LIBERI_WORLD.locations.rewardShop,
        companion: LIBERI_WORLD.genius.singular,
    },
};